import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    ALL_SALES_ORDERS_QUERY,
    ACTIVE_SALES_ORDERS_QUERY,
    SALES_ORDERS_PICKLIST_QUERY,
    SINGLE_SALES_ORDER_QUERY,
    CREAT_SALES_ORDER_MUTATION,
    UPDATE_SALES_ORDER_MUTATION,
    DELETE_SALES_ORDER_MUTATION
} from "@/graphql/sales.js";

const state = {
    allSalesOrders: [],
    activeSalesOrders: [],
    salesOrdersPicklist: [],
    currentSalesOrder: null
};
const getters = {};
const mutations = {
    [types.SET_ALL_SALES_ORDERS](state, sales_orders) {
        state.allSalesOrders = sales_orders;
    },
    [types.SET_ACTIVE_SALES_ORDERS](state, sales_orders) {
        state.activeSalesOrders = sales_orders;
    },
    [types.SET_SALES_ORDERS_PICKLIST](state, sales_orders) {
        state.salesOrdersPicklist = sales_orders;
    },
    [types.SORT_SALES_ORDERS](state) {
        state.sales_orders.sort(function(a, b) {
            return a.node.deliverDatePlanned == b.node.deliverDatePlanned
                ? 0
                : a.node.deliverDatePlanned > b.node.deliverDatePlanned
                ? 1
                : -1;
        });
    },
    [types.UPSERT_SALES_ORDER](state, sales_order) {
        var index = state.sales_orders.findIndex(function(element) {
            return element.node.id == sales_order.id;
        });

        const node = { node: sales_order };

        if (index > -1) {
            state.sales_orders.splice(index, 1, node);
        } else {
            state.sales_orders.unshift(node);
        }
    },
    [types.DELETE_SALES_ORDER](state, sales_order) {
        var index = state.sales_orders.find(function(element, index) {
            if (element.id == sales_order.id) {
                return index;
            }
        });

        if (index > -1) {
            state.sales_orders.splice(index, 1);
        }
    }
};
const actions = {
    async fetchAllSalesOrders(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ALL_SALES_ORDERS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    // console.log(response);
                    const sales_orders =
                        response.data.tenantAllSalesOrders.edges;

                    // update store
                    context.commit(types.SET_ALL_SALES_ORDERS, sales_orders);

                    // // sort
                    // context.commit(types.SORT_SALES_ORDERS);

                    resolve(sales_orders);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchActiveSalesOrders(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ACTIVE_SALES_ORDERS_QUERY,
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    // console.log(response);
                    const sales_orders =
                        response.data.tenantActiveSalesOrders.edges;

                    // update store
                    context.commit(types.SET_ACTIVE_SALES_ORDERS, sales_orders);

                    // // sort
                    // context.commit(types.SORT_SALES_ORDERS);

                    resolve(sales_orders);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSalesOrdersPicklist(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SALES_ORDERS_PICKLIST_QUERY,
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    // console.log(response);
                    const sales_orders =
                        response.data.tenantSalesOrderPicklist.edges;

                    // update store
                    context.commit(
                        types.SET_SALES_ORDERS_PICKLIST,
                        sales_orders
                    );

                    // // sort
                    // context.commit(types.SORT_SALES_ORDERS);

                    resolve(sales_orders);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleSalesOrder(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_SALES_ORDER_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        id: payload
                    }
                })
                .then(response => {
                    const sales_order = JSON.parse(
                        JSON.stringify(response.data.salesOrder)
                    );

                    // // update store
                    // context.commit(types.UPSERT_SALES_ORDER, sales_order);

                    // // sort
                    // context.commit(types.SORT_SALES_ORDERS);

                    resolve(sales_order);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createSalesOrder(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREAT_SALES_ORDER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const sales_order =
                        response.data.createSalesOrder.sales_order;

                    // update store
                    context.commit(types.UPSERT_SALES_ORDER, sales_order);

                    // sort
                    context.commit(types.SORT_SALES_ORDERS);

                    resolve(sales_order);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateSalesOrder(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_SALES_ORDER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const sales_order =
                        response.data.updateSalesOrder.sales_order;

                    // update store
                    context.commit(types.UPSERT_SALES_ORDER, sales_order);

                    // sort
                    context.commit(types.SORT_SALES_ORDERS);

                    resolve(sales_order);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteSalesOrder(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_SALES_ORDER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const sales_order =
                        response.data.deleteSalesOrder.sales_order;

                    // update store
                    context.commit(types.DELETE_SALES_ORDER, sales_order);

                    resolve(sales_order);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
